var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M369 267c-2 19-18 34-38 34-19 0-35-15-37-34h-94v60h600v-60h-60c-2 19-18 34-37 34-20 0-36-15-38-34H369zm0 0h296-296zm-75-75v-30c0-20 17-37 37-37 21 0 38 17 38 37v30h296v-30c0-20 17-37 38-37 20 0 37 17 37 37v30h64c39 0 71 32 71 72v498c0 63-50 113-112 113H238c-63 0-113-50-113-113V264c0-40 32-72 71-72h98zm506 210H200v360c0 21 17 38 38 38h525c20 0 37-17 37-38V402zM298 537c-21 0-38-16-38-37s17-38 38-38h135c20 0 37 17 37 38s-17 37-37 37H298zm0 135c-21 0-38-16-38-37s17-38 38-38h270c20 0 37 17 37 38s-17 37-37 37H298z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar);
export default __webpack_public_path__ + "static/media/ic_calendar.01209891e60cfc66eef93e8f89d33ac0.svg";
export { ForwardRef as ReactComponent };